module.exports = __webpack_public_path__ + "img/ad-contact-xs.116e7e82.jpg";